<template>
  <div id="cc-product-listing">
    <h3 ref="productListingHeader" class="mb-3">{{ displaySelectedCategory }}</h3>
    <div
      class="cc-product-listing-overflow px-3"
      ref="cc-product-listing">
      <template v-if="products.length > 0">
        <ProductTemplate
          v-for="(product, index) in products"
          :key="`product-template-${product.name}-${index}`"
          :uuid="product.uuid"
          :product-index="index"
          class="mb-3">
          <template slot="productName">{{ product.name }}</template>
          <template slot="productPrice">&#8369; {{ getBasePrice(product) | currency }}</template>
        </ProductTemplate>
      </template>
      <div v-else-if="!loading.products && products.length === 0" class="py-2 text-center text-muted">
        No available products.
      </div>
      <div v-if="loading.products" class="py-2 text-center text-muted">
        Loading...
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ProductTemplate from "./ProductTemplate";

export default {
  components: { ProductTemplate },
  computed: {
    ...mapGetters({
      selectedCategory: "conversationalCommerce/selectedCategory",
      categories: "conversationalCommerce/categories",
      loading: "conversationalCommerce/loading",
      products: "conversationalCommerce/products",
      products_pagination: "conversationalCommerce/products_pagination"
    }),
    displaySelectedCategory: {
      get() {
        return this.categories.find(category => category.value === this.selectedCategory).label;
      },
      set(category) {
        return category;
      }
    }
  },
  filters: {
    currency(value) {
      if (!value) return 0;

      return Number(parseFloat(value).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    }
  },
  created() {
    let totalHeight = 0;
    setTimeout(() => {
      const refs = this.$parent.$parent.$refs;
      const thisHeader = this.$refs.productListingHeader.clientHeight;

      totalHeight = totalHeight += refs.rightPanelHeader.$el.clientHeight;
      
      const productListingPanelHeight = refs.productListingPanel.$el.clientHeight - refs.productListingPanel.$refs.productListingComponent.$el.clientHeight;
      
      totalHeight = totalHeight += productListingPanelHeight + thisHeader;

      this.$refs['cc-product-listing'].style.maxHeight = `calc(100vh - ${totalHeight + 16}px)`;
    }, 300);
  },
  methods: {
    getBasePrice(product) {
      const collectPrices = this.products.length > 0
        ? product.inventories.map(inventory => Number(inventory.regular_price))
        : [];
      return Math.min.apply(Math, collectPrices);
    }
  }
}
</script>

<style lang="scss" scoped>
.cc-product-listing-overflow {
  overflow-y: auto;
  margin-left: -1rem;
}
h3 {
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #2F3941;
}
</style>
